import type { RoundTable } from '../../types/round-tables'

interface RoundTableCardProps {
  rt: RoundTable
  onClick: (rt: RoundTable) => void
}

function statusBadge(status: RoundTable['status']) {
  if (status === 'open') {
    return (
      <span className="inline-block px-2 py-0.5 text-swiss-caption font-medium bg-swiss-black text-swiss-white">
        ACTIVE
      </span>
    )
  }
  if (status === 'resolved') {
    return (
      <span className="inline-block px-2 py-0.5 text-swiss-caption font-medium bg-swiss-off-white text-swiss-green border border-swiss-gray-200">
        RESOLVED
      </span>
    )
  }
  return (
    <span className="inline-block px-2 py-0.5 text-swiss-caption font-medium bg-swiss-off-white text-swiss-red border border-swiss-gray-200">
      EXPIRED
    </span>
  )
}

function countdown(expiresAt: string): string {
  const ms = new Date(expiresAt).getTime() - Date.now()
  if (ms <= 0) return '0m'
  const mins = Math.round(ms / 60_000)
  if (mins < 60) return `${mins}m left`
  return `${Math.floor(mins / 60)}h ${mins % 60}m left`
}

export function RoundTableCard({ rt, onClick }: RoundTableCardProps) {
  return (
    <div
      onClick={() => onClick(rt)}
      className="border-b border-swiss-gray-200 px-0 py-4 flex items-start justify-between cursor-pointer hover:bg-swiss-off-white transition-colors duration-100"
    >
      <div className="flex-1 min-w-0 pr-4">
        <div className="text-[14px] font-medium text-swiss-black truncate">{rt.topic}</div>
        {rt.goal && (
          <div className="text-swiss-caption text-swiss-gray-500 mt-0.5 line-clamp-1">{rt.goal}</div>
        )}
        <div className="flex items-center gap-3 mt-1.5">
          <span className="text-swiss-caption font-swiss-mono text-swiss-gray-400">
            {rt.facilitator}
          </span>
          <span className="text-swiss-caption text-swiss-gray-300">·</span>
          <span className="text-swiss-caption font-swiss-mono text-swiss-gray-400">
            {rt.participants.length} participant{rt.participants.length !== 1 ? 's' : ''}
          </span>
          {rt.status === 'open' && (
            <>
              <span className="text-swiss-caption text-swiss-gray-300">·</span>
              <span className="text-swiss-caption font-swiss-mono text-swiss-gray-400">
                {countdown(rt.expires_at)}
              </span>
            </>
          )}
        </div>
      </div>
      <div className="flex-shrink-0 flex items-center gap-3">
        {statusBadge(rt.status)}
        <span className="text-swiss-caption font-swiss-mono text-swiss-gray-400">
          {new Date(rt.created_at).toLocaleDateString()}
        </span>
      </div>
    </div>
  )
}
